import { useTranslation } from 'react-i18next';

import { getOfferedMembershipPlan, isFreeTrialMembershipPlan } from '@/utils/membership-plans';

import { useAvailableMembershipPlans } from './useAvailableMembershipPlans';

const DEFAULT_FREE_TRIAL_DURATION_IN_DAYS = 30;

export const useFreeTrialCtaLabel = (): string => {
  const { t } = useTranslation();
  const { data: membershipPlans } = useAvailableMembershipPlans();
  const offeredPlan = getOfferedMembershipPlan(membershipPlans);
  const numberOfDays =
    isFreeTrialMembershipPlan(offeredPlan) && offeredPlan?.durationInDays != null
      ? offeredPlan.durationInDays
      : DEFAULT_FREE_TRIAL_DURATION_IN_DAYS;

  return t('loyalty.sign-up.try-for-free', { count: numberOfDays });
};
